import { createSelector } from 'reselect';
import ownersAccessSelector from 'redux_store/selectors/dictionary/access/ownersEdit';

const usersPointer = state => state.dictionary.user;
const statusPointer = state => state.dictionary.status;
const userDependencyPointer = state => state.dictionary.userDependency;
const loginPointer = state => state.login;

export default createSelector(
  [usersPointer, statusPointer, userDependencyPointer, loginPointer, ownersAccessSelector],
  (users, status, userDependency, login, ownersAccess) => {
    const { access } = login;
    return {
      dictionary: {
        owners: users.filter(x => x.isActive && ownersAccess.indexOf(x.id) >= 0),
        status,
        userDependency,
      },
      access: {
        statusEdit: access.statusEdit,
        ownerEdit: access.ownerEdit,
      },
      currentUserId: login.id,
    };
  },
);
